export default "__VITE_ASSET__riHCcf0n__"